import { render, staticRenderFns } from "./IconSvgLookupPeople.vue?vue&type=template&id=5d364492&scoped=true&"
import script from "./IconSvgLookupPeople.vue?vue&type=script&lang=js&"
export * from "./IconSvgLookupPeople.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d364492",
  null
  
)

export default component.exports